import React, { useState } from 'react'

import { Button, ButtonGroup, Grid, Row, Col, DropdownButton, MenuItem, Glyphicon } from 'react-bootstrap'

import useSWR from '../../hooks/useSWR'
import ExploringContainer from '../Carrier/Exploring/ExploringContainer'

const activeTabColor = 'rgba(0, 110, 120, 0.5)'

const ReplacementBench = () => {
  const [activeView, setActiveView] = useState('exploring')
  const [selectedRentalCompanies, setSelectedRentalCompanies] = useState([])

  const { data: locks } = useSWR('/subject/admin/locks/replacement-bench')
  const { data: rentalCompanies } = useSWR('/subject/admin/rental_companies')

  const renderReplacementBench = () => {
    if (!locks || !rentalCompanies) return 'loading...'

    const filteredAndSortedRentalCompanies = [{ name: 'Okänt' }]
      .concat(rentalCompanies)
      .reduce((acc, c) => {
        const rentalCompanyLocks = locks.filter((l) => l.rental_company === c._id)

        if (rentalCompanyLocks.length === 0) return acc

        return acc.concat({ ...c, locks: rentalCompanyLocks })
      }, [])
      .sort((a, b) => (a.name > b.name ? 1 : -1))

    return (
      <div>
        <DropdownButton className="delivery-filter-container" title={selectedRentalCompanies.length > 0 ? `Valda: ${selectedRentalCompanies.length} ` : 'Uthyrningsföretag '} id="bg-nested-dropdown">
          <MenuItem style={{ backgroundColor: 'rgb(230, 230, 230)' }} className="dropdown-menu-item" onSelect={() => setSelectedRentalCompanies([])}>
            <div>Återställ filter</div>
          </MenuItem>
          {filteredAndSortedRentalCompanies.map((c) => (
            <MenuItem key={c._id} className="dropdown-menu-item" onSelect={() => setSelectedRentalCompanies(selectedRentalCompanies.includes(c._id) ? selectedRentalCompanies.filter((id) => id !== c._id) : selectedRentalCompanies.concat(c._id))}>
              <div>
                {c.name}
                <Glyphicon glyph={`glyphicon glyphicon-${selectedRentalCompanies.includes(c._id) ? 'check' : 'unchecked'}`} style={{ color: 'grey', marginRight: '5px', marginLeft: '5px', float: 'left' }} />
              </div>
            </MenuItem>
          ))}
        </DropdownButton>
        <br />
        <br />
        {filteredAndSortedRentalCompanies
          .filter((c) => selectedRentalCompanies.length === 0 || selectedRentalCompanies.includes(c._id))
          .map((c) => (
            <div key={c._id}>
              <h4>{`${c.name} (${c.locks.length} st)`}</h4>
              {c.locks.map((l) => (
                <div key={l._id}>{l.custom_name}</div>
              ))}
              <br />
              <br />
            </div>
          ))}
      </div>
    )
  }

  return (
    <Grid style={{ padding: 0, width: '90%' }}>
      <Row>
        <Col xs={12}>
          <ButtonGroup style={{ paddingLeft: 25, paddingBottom: 30, justifyContent: 'center', display: 'flex', width: '100%' }}>
            <Button style={{ flex: 1, background: activeView === 'exploring' ? activeTabColor : '' }} onClick={() => setActiveView('exploring')}>
              Karta
            </Button>
            <Button style={{ flex: 1, background: activeView === 'replacement-bench' ? activeTabColor : '' }} onClick={() => setActiveView('replacement-bench')}>
              Redo att ställas ut
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>{activeView === 'exploring' ? <ExploringContainer /> : renderReplacementBench()}</Col>
      </Row>
    </Grid>
  )
}

export default ReplacementBench
